/**
 * 点击元素外部区域时触发
 * Usage:
 * <div v-click-outside="handleClickOutside">
 * <div v-click-outside:selectors.reverse="handleClickInside">
 *
 * @argument:
 *  selectors: 一个包含了选择器表达式的数组或者字符串
 *             除了 el 本身，指定了 selector 范围的点击，也将认为是 非outside
 */
import $ from 'jquery'
import { sub, unSub, CLICK_OUTSIDE } from '../../core/utils/KGevent'
import _ from 'lodash'

const KEY = 'directive-click-outside'
const KEY_REVERSE = 'directive-click-outside-reverse'

function getKey(binding) {
  if (!binding?.modifiers) {
    return KEY
  }
  return binding.modifiers.reverse
    ? KEY
    : KEY_REVERSE
}

function isClickOutside(el, target, selectors) {
  if (selectors) {
    if (_.isString(selectors)) {
      selectors = [selectors]
    }
    const belongSelectors = _.some(selectors, selector => {
      return $(target).closest(selector).length > 0
    })

    if (belongSelectors) {
      return false
    }
  }

  return !el.contains(target)
}

export default {
  bind(el, binding, vnode) {
    const $el = $(el)
    const key = getKey(binding)

    $el.data(key, {
      innerHandler: binding.value,
      handler(target) {
        if (!vnode.context) {
          return
        }

        const both = binding.modifiers.both
        const reverse = binding.modifiers.reverse
        const selectors = binding.arg
        const clickOutside = isClickOutside(el, target, selectors)

        if (both) {
          binding.value.bind(vnode.context)(target, clickOutside)
          return
        }

        if (reverse) {
          if (!clickOutside) {
            binding.value.bind(vnode.context)(target)
          }
        } else if (clickOutside) {
          binding.value.bind(vnode.context)(target)
        }
      },
    })

    sub(CLICK_OUTSIDE, $el.data(key).handler)
    // sub(CLICK_OUTSIDE, (target, e) => {
    //   console.log('target:', target, e)
    //   console.log('handler: ', $el.data(context).handler)
    // })
  },
  update(el, binding) {
    const key = getKey(binding)
    $(el).data(key).innerHandler = binding.value
  },
  unbind(el, binding) {
    const key = getKey(binding)
    if ($(el).data(key) && $(el).data(key).handler) {
      unSub(CLICK_OUTSIDE, $(el).data(key).handler)
    }
    $(el).data(key, null)
  },
  install(Vue) {
    Vue.directive('click-outside', {
      bind: this.bind,
      unbind: this.unbind,
    })
  },
}
